import { useEffect, useState } from "react";
import styles from "./subscribe.module.css";

export default function Subscribe() {
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [isForbidden, setIsForbidden] = useState(false);
    const [keywords, setKeywords] = useState<string[]>([]);
    const [newKeyword, setNewKeyword] = useState<string>("");
    const [isSaved, setIsSaved] = useState(false);

    useEffect(() => {
        setIsLoaded(false);
        setError(null);
        setIsForbidden(false);

        const fetchKeywords = async () => {
            try {
                const token = localStorage.getItem("token");

                const response = await fetch("/api/subscriptions", {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (response.status === 403) {
                    setIsForbidden(true);
                    return;
                }

                if (!response.ok) {
                    setError('Failed to fetch subscriptions');
                    return;
                }

                const data = await response.json();
                setKeywords(data);
            }
            catch (err) {
                console.log(err);
                setError('Failed to parse subscriptions');
            }
            finally {
                setIsLoaded(true);
            }
        }

        fetchKeywords();
    }, []);

    if (isForbidden) {
        return <p>You are forbidden from viewing the page.</p>
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    if (!isLoaded) {
        return <p>Loading...</p>;
    }

    const removeHandler = (value: string) => {
        const newKeywords = [...keywords].filter(x => x !== value);
        setKeywords(newKeywords);
    }

    const addKeywordHandler = () => {
        const trimmed = newKeyword.trim();

        if (!trimmed) {
            return;
        }

        if (!keywords.includes(trimmed)) {
            const newKeywords = [...keywords, trimmed];
            setKeywords(newKeywords);
        }

        setNewKeyword("");
    }

    const saveChanges = async (e: React.SubmitEvent) => {
        e.preventDefault();
        setIsSaved(false);

        try {
            const token = localStorage.getItem("token");

            const response = await fetch("/api/subscriptions", {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(keywords)
            });

            if (!response.ok) {
                setError("Failed to save subscriptions");
            } else {
                setIsSaved(true);
                setTimeout(() => setIsSaved(false), 3000); // hide after 3 seconds
            }
        } catch (err) {
            setError("Failed to save subscriptions");
        }
    }

    return (
        <div className={styles.container}>
            <form onSubmit={saveChanges}>
                <p className={styles.description}>Get notified in Telegram when somebody sells a board game that matches defined keywords.</p>
                <span className={styles.label}>Existing keywords:</span>
                <ul className={styles.keywordList}>
                    {
                        keywords.map(x => (
                            <li key={x} className={styles.keywordItem}>
                                {x}
                                <input type="button" onClick={() => removeHandler(x)} value="Remove" />
                            </li>
                        ))
                    }
                </ul>
                <span className={styles.label}>Add keyword:</span>
                <div className={styles.addRow}>
                    <input type="text" value={newKeyword} onChange={(e) => setNewKeyword(e.target.value)} />
                    <input type="button" value="Add" onClick={() => addKeywordHandler()} disabled={!newKeyword.trim()} />
                </div>
                <input type="submit" value="Save" />
                {isSaved && <p className={styles.success}>Subscriptions saved successfully!</p>}
            </form>
        </div>
    )
}